import * as Utils from "@shoothill/core";
import { BaseStore, CoreStoreInstance } from "@shoothill/core";
import { action, observable, runInAction } from "mobx";
import { Stores } from "../Stores";
import { InitialState } from "Globals/Models";
import { AccountStatus } from "@shoothill/core";
import { useObserver, useRouter } from "@shoothill/core";

interface AccountStatusExtended extends AccountStore {
    lastName: string;
    firstName: string;
}
export class AccountStore extends BaseStore {
    @observable public IsLoggedIn: boolean = false;
    @observable public UserName: string = "";
    @observable public DisplayName: string = "";
    @observable public UserRoles: string[] = [];
    @observable public FirstName: string = "";
    @observable public LastName: string = "";
    @observable public AllPayBaseUrl: string = "";

    private jwt: string | null = null;
    private refreshToken: string | null = null;
    private refreshTokenExpiryDate: Date | null = null;
    private tokenViewModel = {};

    public constructor() {
        super();
        AccountStoresInstance = this;
    }

    public init(stores: Stores, initialState: InitialState) {
        this.getLoginState(initialState.accountStatus as any);
        this.FirstName = initialState.accountDetails.firstName;
        this.LastName = initialState.accountDetails.lastName;
        this.AllPayBaseUrl = initialState.allPayBaseUrl;
        //this.tokenViewModel = new TokenViewModel();
    }

    @action
    public setIsLoggedIn(state: boolean) {
        this.IsLoggedIn = state;
        CoreStoreInstance.SetLoggedIn(false);
    }

    public isInRole = (role: string): boolean => {
        if (this.UserRoles && this.UserRoles.length > 0) {
            return this.UserRoles.includes(role);
        }
        return false;
    };

    @action
    public Logout = async (redirect: boolean = false): Promise<void> => {
        await Utils.deleteJWT();
        document.cookie = ".refreshtoken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT";
        this.setIsLoggedIn(false);
        this.UserName = "";
        this.DisplayName = "";
        CoreStoreInstance.SetDisplayName("");
        runInAction(() => {
            this.UserRoles = [];
        });
        window.location.href = "/login";
        //(window as any).jwt = null;
        // if (redirect) {
        //     window.location.href = "/";
        // }
    };

    public getJwt = (): string => {
        return this.jwt as string;
    };

    @action
    public getLoginState = async (apiResult: any) => {
        let jwt = apiResult?.jwt ?? "";
        if (!jwt || jwt.length === 0) {
            this.jwt = await Utils.getJWT();
            //this.refreshToken = localStorage.getItem(".refreshToken");
            //this.refreshTokenExpiryDate = new Date(localStorage.getItem(".refreshTokenExpiryDate") as string);
        } else {
            this.jwt = jwt;
        }

        if (this.jwt && this.jwt !== "undefined" && this.jwt !== "null") {
            const data = Utils.parseJwt(this.jwt);
            await Utils.setJWT(this.jwt);
            if (data === "") {
                return;
            }
            //localStorage.setItem(".refreshToken", apiResult?.refreshToken ?? "");
            //localStorage.setItem(".refreshTokenExpiryDate", apiResult?.refreshTokenExpiryDate ?? new Date());
            this.setIsLoggedIn(true);
            runInAction(() => {
                this.UserName = (data as any)["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"] as string;
                this.DisplayName = (data as any)["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name"] as string;
                this.UserRoles = (data as any)["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] as string[];
            });
            this.FirstName = ""; // apiResult?.firstName;
            this.LastName = ""; // apiResult?.lastName;
            CoreStoreInstance.SetDisplayName(this.DisplayName);
            // EN: For Debugging
            //(window as any).jwt = this.jwt;
        }
    };
}
export let AccountStoresInstance = {} as AccountStore;
